import { OfferOrder } from "@/api/orders/types";
import { isExpiredInSeconds } from "@/shared/dates";
import { isEqual } from "@/shared/string";

function getHighestOffer(
  offers: OfferOrder[],
  currentAddress: string | null | undefined,
  nftOwner: string,
) {
  if (!offers.length) return;

  const meOwner = isEqual(nftOwner, currentAddress);

  return offers.reduce((highestOffer, offer) => {
    const meBidder = isEqual(currentAddress, offer.buyer);

    if ((meOwner && meBidder) || isExpiredInSeconds(offer.expiresAt))
      return highestOffer;

    if (!highestOffer || +offer.priceInUSD! < +highestOffer.priceInUSD!) {
      return highestOffer;
    }

    return offer;
  });
}

function getYourOffer(
  offers: OfferOrder[],
  currentAddress: string | null | undefined,
) {
  if (!offers.length) return;

  return offers.find((offer) => isEqual(offer.buyer, currentAddress));
}

export { getHighestOffer, getYourOffer };
